// extracted by mini-css-extract-plugin
export default {"login":"Login_login__gqueq","name-input":"Login_name-input__UqIVA","loading-overlay":"Login_loading-overlay__OkYYs"};